import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  Table,
  Button,
  Row,
  Col,
  FormControl,
  FormGroup,
  ControlLabel,
  Tab,
} from "react-bootstrap";
import Select from "react-select";
import "./MedicineWiseBatchersSelect.css";
import { GetPoListById } from "Listfunction";
import { UpdatePurchaseOrder } from "Listfunction";
import Swal from "sweetalert2";
import NotificationSystem from "react-notification-system";

const PurchaseRequest = ({
  onCreatePurchaseOrder,
  medicineName,
  show,
  onHide,
  isSubmitting,
  getSupplierOption,
  setGetSupplierOption,
  enterPoQty,
  setEnterPoQty,
  setSelectedSupplier,
  selectedSupplier,
  getAllPurchaseOrderByMedId,
  setGetAllPurchaseOrderByMedId,
  openUpdateModal,
  enterDiscount,
  setEnterDiscount,
  getAllSupplierDataPo,
  unitPrice,
  setUnitPrice,
  getFcode,
  setGetFcode,
  getMedicineName,
  setGetMedicineName,
  setOpenCreatePurchaseOrderModal,
  getAllPurchaseRequestOrders,
  changeTheStatus,
  getPurchaseRequestId,
}) => {
  const _notificationSystem = useRef(null);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateQty, setUpdateQty] = useState(1);
  const [updateOrderId, setUpdateOrderId] = useState(null);
  const [poListDataById, setPoListDataById] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [disableSubmitButton, setDisableSubmitButton] = useState(false);

  const handleNumberChange = (event, setValue, currentValue) => {
    const value = event.target.value;
    if (/^[0-9]*\.?[0-9]*$/.test(value)) {
      setValue(value);
    } else {
      event.target.value = currentValue == null ? "" : currentValue;
    }
  };
  const hasValidValues =
    Number.isFinite(Number(enterPoQty)) &&
    Number(enterPoQty) > 0 &&
    Number.isFinite(Number(unitPrice)) &&
    Number(unitPrice) >= 0 &&
    Number.isFinite(Number(enterDiscount)) &&
    Number(enterDiscount) >= 0;

  useEffect(() => {
    setUnitPrice(unitPrice);
    setGetFcode(getFcode);
    setGetMedicineName(getMedicineName);
  }, [unitPrice, getFcode, getMedicineName]);

  const handleOpenUpdateModal = async (orderId) => {
    if (!hasValidValues) {
      await Swal.fire({
        position: "top",
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Quantity is required</div>",
        html: "<div style='font-size:16px;'>Please enter a valid quantity.</div>",
        icon: "warning",
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }
    const data = await getPoListByPoId(orderId);
    const confirmation = await Swal.fire({
      position: "top",
      width: "478px",
      title: "<div style='font-size:26px;font-weight:100;'>Are you sure?</div>",
      html: `<div style='font-size:16px;'>Do you want to update this medicine to this order? ${orderId}</div>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "<span style='font-size:18px;'>Yes</span>",
      cancelButtonText: "<span style='font-size:18px;'>No</span>",
      allowHtml: true,
    });
    if (confirmation.isConfirmed) {
      setUpdateOrderId(orderId);
      handleSubmitUpdate(orderId, data);
    } else {
      setShowUpdateModal(false);
      setUpdateOrderId(null);
    }
  };
  // const handleCloseUpdateModal = () => {
  //   setShowUpdateModal(false);
  //   setUpdateOrderId(null);
  // };
  const handleSubmitUpdate = async (orderId, poData) => {
    const data = poData || poListDataById;
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    // Null check for poListDataById and poListDataById.items
    if (!data || !data.items) {
      await Swal.fire({
        position: "top",
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight:100;'>Order data not loaded</div>",
        icon: "error",
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }
    // Build updated items array: keep all previous, update or add the yellow-highlighted medicine
    let items = data.items ? [...data.items] : [];
    // Try to find the medicine by code or name (adjust as needed)
    const medicineCode = (
      data.medicine_code ||
      data.medicine_name ||
      medicineName ||
      ""
    ).trim();
    let found = false;
    items = items.map((item) => {
      if (
        (item.item_code && item.item_code === medicineCode) ||
        (item.item && item.item === medicineCode) ||
        (item.medicine_name && item.medicine_name === medicineName)
      ) {
        found = true;
        return {
          ...item,
          quantity: Number(enterPoQty),
          price: Number(unitPrice),
          discount: Number(enterDiscount) || 0,
        };
      }
      return item;
    });
    if (!found) {
      // Add as new item (adjust fields as needed)
      items.push({
        item_code: getFcode,
        quantity: Number(enterPoQty),
        price: Number(unitPrice),
        discount: Number(enterDiscount) || 0,
        deals: "B2C",
        tax_rate: "tax",
        discription: getMedicineName,
        // Add more fields if needed
      });
    }
    const fdata = new FormData();
    fdata.append("supplier_id", data.supplier);
    items.forEach((item, index) => {
      console.log(items, "items");
      fdata.append(
        `order[${index}][item_code]`,
        item.item_code || item.item_code || "",
      );
      if (item.discription !== null && item.discription !== undefined) {
        fdata.append(`order[${index}][description]`, item.discription);
      }
      if (item.batch_no !== null && item.batch_no !== undefined) {
        fdata.append(`order[${index}][batch_no]`, item.batch_no);
      }
      if (item.barcode !== null && item.barcode !== undefined) {
        fdata.append(`order[${index}][barcode]`, item.barcode);
      }
      fdata.append(`order[${index}][quantity]`, item.quantity);
      fdata.append(`order[${index}][price]`, item.price);
      fdata.append(`order[${index}][deals]`, item.deals || "B2C");
      fdata.append(`order[${index}][discount]`, Number(item.discount) || 0);
      fdata.append(`order[${index}][tax_rate]`, item.tax_rate || "tax");
      fdata.append(`order[${index}][account]`, item.account || 200);
      fdata.append(
        `order[${index}][free_of_goods]`,
        item.free_of_goods === null || item.free_of_goods === undefined
          ? 0
          : Number(item.free_of_goods),
      );
      fdata.append(`order[${index}][pack_size]`, item.pack_size || 0);
      fdata.append(`order[${index}][pack_price]`, item.pack_price || 0);
      fdata.append(`order[${index}][selling_price]`, item.selling_price || 0);
    });
    const notification = _notificationSystem.current;
    setDisableSubmitButton(true);
    setIsLoading(true);
    const res = await UpdatePurchaseOrder(fdata, obj, orderId);
    if (res.success) {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>PO</b> - Updated Successfully .
          </div>
        ),
        level: "success",
        position: "bl",
        autoDismiss: 3,
      });
      if (changeTheStatus) {
        await changeTheStatus(getPurchaseRequestId);
      }
      // Clear supplier, quantity, and unit price fields
    }
    setTimeout(() => {
      setShowUpdateModal(false);
      setSelectedSupplier && setSelectedSupplier(null);
      setEnterPoQty && setEnterPoQty("");
      setUnitPrice && setUnitPrice("");
      setGetAllPurchaseOrderByMedId && setGetAllPurchaseOrderByMedId([]);
      setUpdateQty("");
      setUpdateOrderId(null);
      setGetSupplierOption([]);
      setOpenCreatePurchaseOrderModal(false);
      getAllPurchaseRequestOrders && getAllPurchaseRequestOrders();
    }, 1000);
  };
  const getPoListByPoId = (orderId) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    return GetPoListById(orderId, obj).then((res) => {
      if (res.data.data) {
        setPoListDataById(res.data.data);
        return res.data.data;
      }
    });
  };
  const discountAmount =
    (Number(enterPoQty) || 0) *
    (Number(unitPrice) || 0) *
    ((Number(enterDiscount) || 0) / 100);
  const totalAmount =
    (Number(enterPoQty) || 0) * (Number(unitPrice) || 0) - discountAmount;
  return (
    <Modal
      show={show}
      onHide={onHide}
      bsSize="lg"
      backdrop="static"
      dialogClassName="po-modal-70"
    >
      <NotificationSystem ref={_notificationSystem} />
      <Modal.Header closeButton>
        <Modal.Title>Purchase Order</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table>
          <thead>
            <tr>
              <th
                style={{
                  fontSize: "16px",
                  width: "30%",
                  textTransform: "uppercase",
                  fontWeight: "600",
                  color: "#333",
                }}
              >
                Medicine Name
              </th>{" "}
              <th
                style={{
                  fontSize: "16px",
                  width: "20%",
                  textTransform: "uppercase",
                  fontWeight: "600",
                  color: "#333",
                }}
              >
                Select Supplier
              </th>
              <th
                style={{
                  fontSize: "16px",
                  width: "10%",
                  textTransform: "uppercase",
                  fontWeight: "600",
                  color: "#333",
                }}
              >
                Quantity
              </th>
              <th
                style={{
                  fontSize: "16px",
                  width: "10%",
                  textTransform: "uppercase",
                  fontWeight: "600",
                  color: "#333",
                }}
              >
                Unit Price
              </th>
              <th
                style={{
                  fontSize: "16px",
                  width: "10%",
                  textTransform: "uppercase",
                  fontWeight: "600",
                  color: "#333",
                }}
              >
                Discount
              </th>
              <th
                style={{
                  fontSize: "16px",
                  width: "20%",
                  textTransform: "uppercase",
                  fontWeight: "600",
                  color: "#333",
                }}
              >
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <FormControl
                  type="text"
                  name="Medicine"
                  placeholder="Medicine Name"
                  value={medicineName || ""}
                  readOnly
                />
              </td>{" "}
              <td>
                <Select
                  placeholder="Select Supplier"
                  options={getSupplierOption}
                  value={selectedSupplier}
                  onChange={(value) => {
                    setSelectedSupplier(value);
                    if (value && value.value) {
                      getAllSupplierDataPo(value.value);
                    } else {
                      getAllSupplierDataPo("");
                    }
                  }}
                  isClearable
                />
              </td>
              <td>
                <FormControl
                  placeholder="Qty"
                  type="text"
                  inputMode="decimal"
                  name="qty"
                  min="1"
                  required
                  //   inputRef={(el) => {
                  //     qtyInputRef.current = el;
                  //   }}
                  value={enterPoQty}
                  disabled={!!isSubmitting}
                  onKeyDown={(e) => {
                    if (["-", "+", "e", "E"].includes(e.key))
                      e.preventDefault();
                  }}
                  onChange={(e) =>
                    handleNumberChange(e, setEnterPoQty, enterPoQty)
                  }
                  onWheel={(e) => e.target.blur()}
                />
              </td>
              <td>
                <FormControl
                  placeholder="Unit Price"
                  type="text"
                  inputMode="decimal"
                  min={0}
                  value={unitPrice}
                  onKeyDown={(e) => {
                    if (["-", "+", "e", "E"].includes(e.key))
                      e.preventDefault();
                  }}
                  onChange={(e) =>
                    handleNumberChange(e, setUnitPrice, unitPrice)
                  }
                  onWheel={(e) => e.target.blur()}
                />
              </td>
              <td>
                <FormControl
                  placeholder="Discount"
                  type="text"
                  inputMode="decimal"
                  min={0}
                  value={enterDiscount}
                  onKeyDown={(e) => {
                    if (["-", "+", "e", "E"].includes(e.key))
                      e.preventDefault();
                  }}
                  onChange={(e) =>
                    handleNumberChange(e, setEnterDiscount, enterDiscount)
                  }
                  onWheel={(e) => e.target.blur()}
                />
              </td>
              <td>
                <FormControl
                  placeholder="Total Amount"
                  type="number"
                  value={totalAmount}
                  readOnly
                />
              </td>
            </tr>
          </tbody>
        </Table>
      </Modal.Body>
      <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
        <Table style={{ textAlign: "center" }}>
          <thead>
            <tr>
              <th style={{ textAlign: "center" }}>Order ID</th>
              <th style={{ textAlign: "center" }}>Supplier Name</th>
              <th style={{ textAlign: "center" }}>Created At</th>
              <th style={{ textAlign: "center" }}>status</th>
              <th style={{ textAlign: "center" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {getAllPurchaseOrderByMedId &&
            getAllPurchaseOrderByMedId.length > 0 ? (
              getAllPurchaseOrderByMedId.map((order) => (
                <tr key={order.id}>
                  <td>{order.id}</td>
                  <td>{order.supplier.name || order.supplier_id}</td>
                  <td>{order.created_at}</td>
                  <td>
                    {order.order_status == 1
                      ? "Draft"
                      : order.order_status == 2
                        ? "Pending"
                        : order.order_status == 3
                          ? "Completed"
                          : order.order_status == 4
                            ? "Approved"
                            : ""}
                  </td>
                  <td>
                    <button
                      className="btn btn-primary"
                      disabled={!!isSubmitting || !hasValidValues}
                      onClick={() => {
                        handleOpenUpdateModal(order.id);
                      }}
                    >
                      Update Order
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} style={{ textAlign: "center" }}>
                  No purchase orders found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      {/* <UpdateOrderModal
        show={showUpdateModal}
        onHide={handleCloseUpdateModal}
        onSubmit={handleSubmitUpdate}
        qty={updateQty}
        setQty={setUpdateQty}
        setDisableSubmitButton={isSubmitting}
      /> */}
      <Modal.Footer>
        <button type="button" className="btn btn-danger" onClick={onHide}>
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-success"
          onClick={onCreatePurchaseOrder}
          disabled={!!isSubmitting || !hasValidValues}
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default PurchaseRequest;
